import { useScrollToTop } from '@utils/hooks/useScrollToTop';
import CustomTablePagination from '@widgets/tables/main/CustomTablePagination';
import { useRef } from 'react';
import { Loader } from 'rsuite';
import { useTranslation } from 'react-i18next';
import EmptyData from '@shared/ui/messages/EmptyData';

export default function CustomTableMobile({
  children,
  params,
  setParams,
  totalCount,
  filteredCount,
  isLoading,
  isInitialized,
  search,
  filtersCount,
  data,
  hidePagination,
}) {
  const listRef = useRef(null);
  const scrollToTop = useScrollToTop(listRef);
  const { t } = useTranslation();
  const handleSetParams = (newParams) => {
    setParams(newParams);
    scrollToTop();
  };

  return (
    <>
      <div className="tableMobile__list-container">
        {isLoading && !isInitialized && <Loader center />}

        {data?.length > 0 && isInitialized && (
          <div className="tableMobile__list" ref={listRef}>
            {children}
          </div>
        )}

        {data?.length === 0 && isInitialized && !isLoading && (
          <EmptyData
            text={
              search || filtersCount
                ? t('nothing_yet_change_filters')
                : t('no_data_found')
            }
          />
        )}
      </div>
      {!hidePagination && (
        <CustomTablePagination
          page={params?.page || 1}
          perPage={params?.per_page || 10}
          setPage={(value) => handleSetParams({ ...params, page: value })}
          setPerPage={(value) =>
            handleSetParams({ ...params, per_page: value, page: 1 })
          }
          total={totalCount || 0}
          filteredCount={filteredCount || 0}
        />
      )}
    </>
  );
}
